const accordionData = [
    {  
        name: "ОБЩАЯ СТОМАТОЛОГИЯ",      
        services:[
            {
                id:1,
                serviceName: "Прием (осмотр, консультация) врача-стоматолога первичный",
                price: "500",
            },
            {
                id:2,
                serviceName: "Инфильтрационная анестезия",
                price: "500",
             
            },
            {
                id:3,
                serviceName: "Проводниковая анестезия",
                price: "500",
              
            },
            {
                id:4,
                serviceName: "Радиовизиография челюстно-лицевой области",
                price: "500",
              
            },
            {
                id:5,
                serviceName: "Наложение коффердама",
                price: "500",
              
            },
        ] 
    }, 
    {  
        name: "ЛЕЧЕНИЕ КАРИЕСА",
        services:[
            {
                id:6,
                serviceName: "Запечатывание фиссуры зуба герметиком",
                price: "2000",
            },
            {
                id:7,
                serviceName: "Восстановление зуба пломбой",
                price: "3000",
           
            },
            {
                id:8,
                serviceName: "Восстановление зуба пломбой с использованием материалов из фотополимеров",
                price: "6000",

            },
            {
                id:9,
                serviceName: "Сложное эстетико-функциональное восстановление зуба с помощью композита",
                price: "9000",
            
            },
        
        ]
    },    
    {  
        name: "ЛЕЧЕНИЕ ОСЛОЖНЕНИЙ КАРИЕСА",
        services:[
            {
                id:11,
                serviceName: "Инструментальная и медикаментозная обработка корневого канала",
                price: "2000",
               
            },
            {
                id:12,
                serviceName: "Инструментальная и медикаментозная обработка хорошо проходимого корневого канала",
                price: "2500",
             
            },
            {
                id:13,
                serviceName: "Инструментальная и медикаментозная обработка плохо проходимого корневого канала",
                price: "3000",
              
            },
            {
                id:14,
                serviceName: "Временное пломбирование лекарственным препаратом корневого канала",
                price: "500",
            
            },
            {
                id:15,
                serviceName: "Наложение временной пломбы",
                price: "500",
             
            },
            {
                id:16,
                serviceName: "Пломбирование корневого канала зуба",
                price: "500",
            
            },
            {
                id:17,
                serviceName: "Пломбирование корневого канала зуба гуттаперчевыми штифтами",
                price: "1500",
            
            },
            {
                id:18,
                serviceName: "Распломбировка корневого канала ранее леченного",
                price: "1000",
            
            },
            {
                id:19,
                serviceName: "Закрытие перфорации стенки корневого канала зуба",
                price: "2000",
            },
            {
                id:20,
                serviceName: "Временное восстановление разрушенного зуба композитом",
                price: "3000",
            
            },
            {
                id:21,
                serviceName: "Удаление внутриканального штифта/ вкладки",
                price: "2500",
            
            },
        ]
    },   
    {   
        name: "ПРОФЕССИОНАЛЬНАЯ ГИГИЕНА",
        services:[
            {
                id:22,
                serviceName: "Профессиональная гигиена полости рта и зубов",
                price: "5000",
               
            },
            {
                id:23,
                serviceName: "Ультразвуковое удаление наддесневых и поддесневых зубных отложений в области зуба",
                price: "3000",
               
            },
            {
                id:24,
                serviceName: "Лечение повышенной чувствительности (1 зуб)",
                price: "300",
               
            },
        ]
    },
    {  
        name: "ОТБЕЛИВАНИЕ",       
        services:[
            {
                id:25,
                serviceName: "Профессиональное отбеливание зубов ZOOM",
                price: "20000",
                
            },
            {
                id:26,
                serviceName: "Домашнее отбеливание",
                price: "12000",
              
            },
            {
                id:27,
                serviceName: "Обучение гигиене полости рта и зубов индивидуальное, подбор средств и предметов гигиены полости рта",
                price: "1000",
               
            },
        ]
    },
    {  
        name: "ПРОТЕЗИРОВАНИЕ НЕСЪЕМНОЕ",       
        services:[
            {
                id:28,
                serviceName: "Снятие оттиска с одной челюсти",
                price: "1000",
               
            },
            {
                id:29,
                serviceName: "Моделирование воском одного зуба (WAX-UP)",
                price: "2000",
               
            },
            {
                id:30,
                serviceName: "Снятие несъемной ортопедической конструкции",
                price: "1500",
              
            },
            {
                id:31,
                serviceName: "Восстановление зуба вкладками, полукоронкой цельнокерамической",
                price: "22000",
                
            },
            {
                id:32,
                serviceName: "Восстановление зуба  виниром",
                price: "25000",
              
            },
            {
                id:33,
                serviceName: "Восстановление зуба временной коронкой на имплантате",
                price: "12000",
               
            },
            {
                id:34,
                serviceName: "Восстановление зуба временной коронкой (Prettau)",
                price: "7000",
               
            },
            {
                id:35,
                serviceName: "Восстановление зуба цельнолитой коронкой",
                price: "15000",
               
            },
            {
                id:36,
                serviceName: "Восстановление зуба металлокерамической  коронкой",
                price: "16000",
            },
            {
                id:37,
                serviceName: "Восстановление зуба временной коронкой",
                price: "5000",
            },
            {
                id:38,
                serviceName: "Восстановление зуба коронкой на основе диоксида циркония",
                price: "26000",
                
            },
            {
                id:39,
                serviceName: "Фиксация на постоянный цемент несъемных ортопедических конструкций",
                price: "1500",
                
            },
            {
                id:40,
                serviceName: "Восстановление зуба пломбировочными материалами с использованием анкерных штифтов",
                price: "7000",
            },
            {
                id:41,
                serviceName: "Протезирование зуба с использованием имплантата (на основе диоксида циркония)",
                price: "35000",
                
            },
            {
                id:42,
                serviceName: "Протезирование зуба с использованием имплантата (цельнокерамическая коронка, индивидуальный абатмент)",
                price: "45000",
            },
            {
                id:43,
                serviceName: "Изготовление  защитной каппы",
                price: "7000",
            },
            {
                id:44,
                serviceName: "Фиксация внутриканального штифта",
                price: "1500",
                
            },
        ]
    },
    {   
        name: "ПРОТЕЗИРОВАНИЕ СЪЕМНОЕ",
        services:[
            {
                id:45,
                serviceName: "Определение прикуса",
                price: "5000",
                
            },
            {
                id:46,
                serviceName: "Протезирование частичными съемными пластиночными протезами",
                price: "25000",
               
            },
            {
                id:47,
                serviceName: "Протезирование зубов полными съемными пластиночными протезами",
                price: "25000",
                
            },
            {
                id:48,
                serviceName: "Протезирование съемными бюгельными протезами с кламмерной фиксацией",
                price: "75000",
                
            },
            {
                id:49,
                serviceName: "Протезирование съемными бюгельными протезами с замковой фиксацией",
                price: "100000",
                
            },
            {
                id:50,
                serviceName: "Изготовление съемного протеза  на балке (4 имплантата)",
                price: "180000",
                
            },
            {
                id:51,
                serviceName: "Изготовление частичного съемного протеза",
                price: "10000",
               
            },
            {
                id:52,
                serviceName: "Починка съемного протеза",
                price: "5000",
                
            },
            {
                id:53,
                serviceName: "Перебазировка съемного протеза",
                price: "5000",
               
            },
            {
                id:54,
                serviceName: "Изготовление  индивидуальной ложки",
                price: "1000",
               
            },
            {
                id:55,
                serviceName: "Эластичная прокладка для съемного протеза",
                price: "2000",
               
            },
        ]
    },
    {   
        name: "ХИРУРГИЯ",
        services:[
          
            {
                id:57,
                serviceName: "Удаление постоянного зуба",
                price: "3500",
               
            },
            {
                id:58,
                serviceName: "Удаление зуба сложное с разъединением корней",
                price: "5000",
               
            },
            {
                id:59,
                serviceName: "Удаление ретинированного, дистопированного или сверхкомплектного зуба",
                price: "7000",
                
            },
            {
                id:60,
                serviceName: "Вскрытие и дренирование абсцесса полости рта",
                price: "2000",
               
            },
            {
                id:61,
                serviceName: "Лечение альвеолита",
                price: "2000",
               
            },
            {
                id:62,
                serviceName: "Перевязка после хирургического вмешательства",
                price: "500",
               
            },
            {
                id:63,
                serviceName: "Пластика десны аутотрансплантатом в области одного сегмента",
                price: "5000",
              
            },
            {
                id:64,
                serviceName: "Открытый синус-лифтинг (костная пластика, остеопластика)",
                price: "60000",
               
            },
            {
                id:65,
                serviceName: "Закрытый синус-лифтинг (костная пластика, остеопластика)",
                price: "10000",
                
            },
            {
                id:66,
                serviceName: "Аугментация кости (пластика альвеолярного отростка) в области одного сегмента",
                price: "10000",
               
            },
            {
                id:67,
                serviceName: "Вестибулопластика",
                price: "10000",
                
            },
            {
                id:68,
                serviceName: "Пластика перфорации верхнечелюстной пазухи",
                price: "5000",
               
            },
            {
                id:69,
                serviceName: "Цистотомия или цистэктомия",
                price: "5000",
                
            },
            {
                id:70,
                serviceName: "Инъекция",
                price: "500",
                
            },
            {
                id:71,
                serviceName: "Удаление швов",
                price: "500",
               
            },
            {
                id:72,
                serviceName: "Забор крови из вены",
                price: "200",
                
            },
            {
                id:73,
                serviceName: "Внесение лекарственного препарата в лунку",
                price: "500",
                
            },
            {
                id:74,
                serviceName: "Наложение швов",
                price: "500",
                
            }
        ]
    },
    {  
        name: "ИМПЛАНТАЦИЯ",      
        services:[
            {
                id:75,
                serviceName: "Внутрикостная дентальная имплантация ST",
                price: "30000",
                
            },
            {
                id:76,
                serviceName: "Внутрикостная дентальная имплантация AnyRidge",
                price: "40000",
                
            },
            {
                id:77,
                serviceName: "Установка формирователя десны",
                price: "3000",
            }
        ]
    },
        ]
        
    export default accordionData;